import React from "react";
import Popup from "reactjs-popup";
import { appDomain, appEmit } from "../../domain/AppDomain";
import { EventNames } from "../../domain/events/Events";
import { BaseComponent } from "../core/BaseComponent";
import "./InMeetingPopup.css";


interface InMeetingPopupProps {
    currentlyInMeeting: boolean;
}

export class InMeetingPopup extends BaseComponent<InMeetingPopupProps> {

    async inMeetingForMinutes(minutesInMeeting: number, closeFn: any) {
        await appDomain.IEmployeeAbsenceService.setInMeeting(minutesInMeeting);
        closeFn();
        setTimeout(() => appEmit(EventNames.reloadAbsences), 1000);
    }

    async onPopupTrigger() {
        await appDomain.IEmployeeAbsenceService.setMeetingOver();
        appEmit(EventNames.reloadAbsences);
    }

    render() {
        return (

            this.props.currentlyInMeeting ? (
                <div onClick={this.onPopupTrigger} className="in-meeting">
                    {this.translate("attentiondays.out-meeting")}
                </div>
            ) : (
                <Popup trigger={< div className="in-meeting" > {this.translate("attentiondays.in-meeting")}</div>} modal closeOnDocumentClick>
                    {(close: any) => (

                        <div className="modal">
                            <div className="close" onClick={close}> <span className="close-sign">+</span>
                            </div>
                            <div className="content">
                                <button className="in-meeting-button" onClick={() => this.inMeetingForMinutes(30, close)}> Half uur</button>
                                <button className="in-meeting-button" onClick={() => this.inMeetingForMinutes(60, close)}> 1 uur</button>
                                <button className="in-meeting-button" onClick={() => this.inMeetingForMinutes(120, close)}> 2 uur</button>
                            </div>

                            <button className="cancel-button" onClick={() => close()}>Annuleren</button>
                        </div>
                    )}
                </Popup>
            )
        )
    }
}
